const tableEmptyInfomationCNTraditional = {
  "-table-empty-title": "目前尚無資料",
  "-table-empty-desc": "",
  "sequence-list-table-empty-title": "尚未創建工作流程",
  "sequence-list-table-empty-desc":
    "根據您的需求設計序列，開始建立您的銷售策略。按一下 [+ 新工作流程] 即可開始。",
  "sequence-detail-inbox-table-empty-title": "尚未傳送訊息",
  "sequence-detail-inbox-table-empty-desc":
    "透過監控工作流程的訊息傳送，確保有效率的通訊。目前，沒有訊息透過工作流程傳送。",
  "setting-notification-table-empty-title": "暫無通知",
  "setting-notification-table-empty-desc":
    "看起來暫時沒有任何新消息，請稍後再回來查看更新和通知。",
  "setting-billing-history-table-empty-title": "尚未有帳單記錄",
  "setting-billing-history-table-empty-desc":
    "看起來您還沒有付款。一旦您開始使用我們的付費功能，您的帳單歷史記錄將會顯示在這裡。",
  "setting-role-table-empty-title": "無角色建立",
  "setting-role-table-empty-desc":
    "角色可協助您管理團隊內的權限，建立角色來定義使用者的存取等級。",
  "setting-roles-users-table-empty-title": "沒有指派使用者",
  "setting-roles-users-table-empty-desc":
    "此角色目前沒有指定使用者。開始新增團隊成員，定義他們的職責並簡化工作流程。",
  "setting-team-table-empty-title": "未建立團隊",
  "setting-team-table-empty-desc":
    "團隊可讓您與不同的群組組織和協作，從建立一個新團隊開始。",
  "setting-teams-users-table-empty-title": "沒有指派使用者",
  "setting-teams-users-table-empty-desc":
    "此角色目前沒有指定使用者。開始新增團隊成員，定義他們的職責並簡化工作流程。",
  "setting-users-table-empty-title": "無使用者新增",
  "setting-users-table-empty-desc":
    "使用者加入後會出現在這裡。您可以邀請團隊成員加入您的平台進行協同工作。",
  "setting-custom-field-table-empty-title": "尚未有自訂聯絡欄位",
  "setting-custom-field-table-empty-desc": "",
  "setting-api-keys-table-empty-title": "未產生 API 金鑰",
  "setting-api-keys-table-empty-desc":
    "API 金鑰可讓您與外部服務整合。建立新的 API 金鑰，開始連接您的系統。",

  "sequence_detail_logs-table-empty-title": "暫無日誌記錄",
  "sequence_detail_logs-table-empty-desc": "系統驅動，操作處理完成後自動填充。",

  "sequence_report_interactions-table-empty-title": "暫無互動記錄",
  "sequence_report_interactions-table-empty-desc":
    "目前此步驟暫無互動記錄。當收件人參與後，他們的活動將在此顯示。",

  "sequence_detail_targets-table-empty-title": "尚未分配目標",
  "sequence_detail_targets-table-empty-desc":
    "為此節點分配目標以啟動序列。新增後，其狀態和進度將在此顯示。",
};

export default tableEmptyInfomationCNTraditional;

export const tableEmptyInformationJapanese = {
  "-table-empty-title": "現在データがありません",
  "-table-empty-desc": "",
  "sequence-list-table-empty-title": "ワークフローがまだ作成されていません",
  "sequence-list-table-empty-desc":
    "ニーズに合わせてシーケンスを設計し、セールス戦略を作成しましょう。[+ 新規ワークフロー]をクリックして開始します。",
  "sequence-detail-inbox-table-empty-title": "メッセージが送信されていません",
  "sequence-detail-inbox-table-empty-desc":
    "ワークフローによるメッセージ送信を監視し、効率的なコミュニケーションを確保します。現在、ワークフローを通じて送信されたメッセージはありません。",
  "setting-notification-table-empty-title": "通知はありません",
  "setting-notification-table-empty-desc":
    "新しいメッセージは現在ありません。更新や通知については後で確認してください。",
  "setting-billing-history-table-empty-title": "請求履歴がありません",
  "setting-billing-history-table-empty-desc":
    "まだお支払いがありません。有料機能をご利用になりましたら、ここに請求履歴が表示されます。",
  "setting-role-table-empty-title": "ロールが作成されていません",
  "setting-role-table-empty-desc":
    "ロールを使用してチーム内の権限を管理し、ユーザーのアクセスレベルを定義できます。",
  "setting-roles-users-table-empty-title": "ユーザーが割り当てられていません",
  "setting-roles-users-table-empty-desc":
    "このロールには現在ユーザーが割り当てられていません。チームメンバーを追加して、責任を定義しワークフローを効率化しましょう。",
  "setting-team-table-empty-title": "チームが作成されていません",
  "setting-team-table-empty-desc":
    "チームを作成すると、異なるグループと組織的に協力できます。新しいチームを作成することから始めましょう。",
  "setting-teams-users-table-empty-title": "ユーザーが割り当てられていません",
  "setting-teams-users-table-empty-desc":
    "このロールには現在ユーザーが割り当てられていません。チームメンバーを追加して、責任を定義しワークフローを効率化しましょう。",
  "setting-users-table-empty-title": "ユーザーが追加されていません",
  "setting-users-table-empty-desc":
    "ユーザーが参加するとここに表示されます。チームメンバーをプラットフォームに招待して共同作業を行いましょう。",
  "setting-custom-field-table-empty-title":
    "カスタム連絡先フィールドがありません",
  "setting-custom-field-table-empty-desc": "",
  "setting-api-keys-table-empty-title": "APIキーが生成されていません",
  "setting-api-keys-table-empty-desc":
    "APIキーを使用して外部サービスと統合できます。新しいAPIキーを作成し、システムの接続を開始しましょう。",

  "sequence_detail_logs-table-empty-title": "ログはまだありません",
  "sequence_detail_logs-table-empty-desc":
    "システム駆動で、アクション処理後に自動的に入力されます。",

  "sequence_report_interactions-table-empty-title": "表示するインタラクションがありません",
  "sequence_report_interactions-table-empty-desc":
    "現在、このステップにはインタラクションがありません。受信者が参加すると、その活動がここに表示されます。",

  "sequence_detail_targets-table-empty-title": "ターゲットがまだ割り当てられていません",
  "sequence_detail_targets-table-empty-desc":
    "シーケンスを開始するには、このノードにターゲットを割り当ててください。追加後、そのステータスと進捗状況がここに表示されます。",

  "setting-api-keys-logs-table-empty-title": "API ログが記録されていません",
  "setting-api-keys-logs-table-empty-desc":
    "API キーが生成・使用されると、ここにログが表示されます。このセクションで API の使用状況とアクティビティを監視してください。",
};

export const tableEmptyInformationKorean = {
  "-table-empty-title": "현재 데이터가 없습니다",
  "-table-empty-desc": "",
  "sequence-list-table-empty-title": "워크플로우가 아직 생성되지 않았습니다",
  "sequence-list-table-empty-desc":
    "요구사항에 맞게 시퀀스를 설계하고 영업 전략을 구축하세요. [+ 새 워크플로우]를 클릭하여 시작하세요.",
  "sequence-detail-inbox-table-empty-title": "메시지가 전송되지 않았습니다",
  "sequence-detail-inbox-table-empty-desc":
    "워크플로우를 통해 메시지 전송을 모니터링하여 효율적인 커뮤니케이션을 보장하세요. 현재 워크플로우를 통해 전송된 메시지가 없습니다.",
  "setting-notification-table-empty-title": "알림이 없습니다",
  "setting-notification-table-empty-desc":
    "새로운 메시지가暂时 없습니다. 업데이트 및 알림을 확인하려면 나중에 다시 확인해 주세요.",
  "setting-billing-history-table-empty-title": "결제 내역이 없습니다",
  "setting-billing-history-table-empty-desc":
    "아직 결제를 하지 않으셨습니다. 유료 기능을 사용하기 시작하면 여기에 결제 내역이 표시됩니다.",
  "setting-role-table-empty-title": "역할이 생성되지 않았습니다",
  "setting-role-table-empty-desc":
    "역할을 통해 팀 내 권한을 관리하고 사용자 액세스 수준을 정의할 수 있습니다.",
  "setting-roles-users-table-empty-title": "할당된 사용자가 없습니다",
  "setting-roles-users-table-empty-desc":
    "이 역할에는 현재 사용자가 할당되지 않았습니다. 팀 멤버를 추가하고 책임을 정의하여 워크플로우를 간소화하세요.",
  "setting-team-table-empty-title": "팀이 생성되지 않았습니다",
  "setting-team-table-empty-desc":
    "팀을 통해 다양한 그룹과 조직적으로 협업할 수 있습니다. 새 팀을 생성하는 것부터 시작하세요.",
  "setting-teams-users-table-empty-title": "할당된 사용자가 없습니다",
  "setting-teams-users-table-empty-desc":
    "이 역할에는 현재 사용자가 할당되지 않았습니다. 팀 멤버를 추가하고 책임을 정의하여 워크플로우를 간소화하세요.",
  "setting-users-table-empty-title": "추가된 사용자가 없습니다",
  "setting-users-table-empty-desc":
    "사용자가 참여하면 여기에 표시됩니다. 팀 멤버를 플랫폼에 초대하여 협업을 진행하세요.",
  "setting-custom-field-table-empty-title":
    "사용자 지정 연락처 필드가 없습니다",
  "setting-custom-field-table-empty-desc": "",
  "setting-api-keys-table-empty-title": "API 키가 생성되지 않았습니다",
  "setting-api-keys-table-empty-desc":
    "API 키를 사용하여 외부 서비스와 통합할 수 있습니다. 새 API 키를 생성하여 시스템 연결을 시작하세요.",

  "sequence_detail_logs-table-empty-title": "로그를 사용할 수 없습니다",
  "sequence_detail_logs-table-empty-desc":
    "시스템 주도로, 작업 처리 후 자동으로 채워집니다.",

  "sequence_report_interactions-table-empty-title": "표시할 상호작용이 없습니다",
  "sequence_report_interactions-table-empty-desc":
    "현재 이 단계에는 상호작용이 없습니다. 수신자가 참여하면 해당 활동이 여기에 표시됩니다.",

  "sequence_detail_targets-table-empty-title": "아직 할당된 대상이 없습니다",
  "sequence_detail_targets-table-empty-desc":
    "시퀀스를 시작하려면 이 노드에 대상을 할당하세요. 추가 후 상태 및 진행 상황이 여기에 표시됩니다.",

  "setting-api-keys-logs-table-empty-title": "API 로그가 기록되지 않았습니다",
  "setting-api-keys-logs-table-empty-desc":
    "API 키가 생성되고 사용되면 여기에 로그가 표시됩니다. 이 섹션에서 API 사용 현황과 활동을 모니터링하세요.",
};

export const tableEmptyInformationHindi = {
  "-table-empty-title": "अभी कोई डेटा नहीं है",
  "-table-empty-desc": "",
  "sequence-list-table-empty-title": "अभी तक कोई वर्कफ़्लो नहीं बनाया गया है",
  "sequence-list-table-empty-desc":
    "अपनी आवश्यकताओं के अनुसार अनुक्रम डिज़ाइन करें और अपनी बिकनी रणनीति बनाना शुरू करें। [+ नया वर्कफ़्लो] पर क्लिक करके शुरू करें।",
  "sequence-detail-inbox-table-empty-title": "अभी तक कोई संदेश नहीं भेजा गया",
  "sequence-detail-inbox-table-empty-desc":
    "वर्कफ़्लो द्वारा संदेश भेजने की निगरानी करके कुशल संचार सुनिश्चित करें। फिलहाल, वर्कफ़्लो के माध्यम से कोई संदेश नहीं भेजा गया है।",
  "setting-notification-table-empty-title": "अभी कोई सूचना नहीं है",
  "setting-notification-table-empty-desc":
    "लगता है अभी कोई नया संदेश नहीं है, अपडेट और सूचनाओं के लिए बाद में पुनः जांचें।",
  "setting-billing-history-table-empty-title":
    "अभी तक कोई बिलिंग इतिहास नहीं है",
  "setting-billing-history-table-empty-desc":
    "लगता है आपने अभी तक भुगतान नहीं किया है। जैसे ही आप हमारी सशुल्क सुविधाओं का उपयोग शुरू करेंगे, आपका बिलिंग इतिहास यहां दिखाई देगा।",
  "setting-role-table-empty-title": "कोई भूमिका नहीं बनाई गई",
  "setting-role-table-empty-desc":
    "भूमिकाएं आपको टीम के भीतर अनुमतियों को प्रबंधित करने में मदद करती हैं, उपयोगकर्ता पहुंच स्तर को परिभाषित करने के लिए भूमिकाएं बनाएं।",
  "setting-roles-users-table-empty-title": "कोई उपयोगकर्ता नियत नहीं किया गया",
  "setting-roles-users-table-empty-desc":
    "इस भूमिका में फिलहाल कोई उपयोगकर्ता नियत नहीं किया गया है। टीम सदस्यों को जोड़ना शुरू करें, उनकी जिम्मेदारियां परिभाषित करें और वर्कफ़्लो को सुव्यवस्थित करें।",
  "setting-team-table-empty-title": "कोई टीम नहीं बनाई गई",
  "setting-team-table-empty-desc":
    "टीमें आपको विभिन्न समूहों के साथ संगठित और सहयोग करने देती हैं, एक नई टीम बनाकर शुरुआत करें।",
  "setting-teams-users-table-empty-title": "कोई उपयोगकर्ता नियत नहीं किया गया",
  "setting-teams-users-table-empty-desc":
    "इस भूमिका में फिलहाल कोई उपयोगकर्ता नियत नहीं किया गया है। टीम सदस्यों को जोड़ना शुरू करें, उनकी जिम्मेदारियां परिभाषित करें और वर्कफ़्लो को सुव्यवस्थित करें।",
  "setting-users-table-empty-title": "कोई उपयोगकर्ता नहीं जोड़ा गया",
  "setting-users-table-empty-desc":
    "उपयोगकर्ता जुड़ने के बाद यहां दिखाई देंगे। आप अपनी टीम के सदस्यों को प्लेटफॉर्म पर आमंत्रित कर सहयोग कर सकते हैं।",
  "setting-custom-field-table-empty-title":
    "अभी तक कोई कस्टम संपर्क फ़ील्ड नहीं है",
  "setting-custom-field-table-empty-desc": "",
  "setting-api-keys-table-empty-title": "कोई API कुंजी उत्पन्न नहीं की गई",
  "setting-api-keys-table-empty-desc":
    "API कुंजियां आपको बाहरी सेवाओं के साथ एकीकृत करने देती हैं। नई API कुंजी बनाकर अपने सिस्टम को कनेक्ट करना शुरू करें।",

  "sequence_detail_logs-table-empty-title": "अभी कोई लॉग उपलब्ध नहीं",
  "sequence_detail_logs-table-empty-desc":
    "सिस्टम-संचालित, एक्शन प्रोसेस होने के बाद स्वचालित रूप से भर जाता है।",

  "sequence_report_interactions-table-empty-title": "दिखाने के लिए कोई इंटरैक्शन नहीं",
  "sequence_report_interactions-table-empty-desc":
    "वर्तमान में इस चरण के लिए कोई इंटरैक्शन नहीं है। जब आपके प्राप्तकर्ता संलग्न होंगे, तो उनकी गतिविधि यहां दिखाई देगी。",

  "sequence_detail_targets-table-empty-title": "अभी तक कोई टारगेट असाइन नहीं किए गए",
  "sequence_detail_targets-table-empty-desc":
    "अनुक्रम शुरू करने के लिए इस नोड को टारगेट असाइन करें। एक बार जोड़ने के बाद, उनकी स्थिति और प्रगति यहां दिखाई देगी।",

  "setting-api-keys-logs-table-empty-title": "कोई API लॉग दर्ज नहीं किए गए",
  "setting-api-keys-logs-table-empty-desc":
    "API कुंजियां उत्पन्न और उपयोग होने के बाद, यहाँ लॉग प्रदर्शित होंगे। इस अनुभाग में अपनी API गतिविधि और उपयोग की निगरानी करें।",
};
